import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function PortalInactivateObservable(implementationID: number): Observable<string> {
  const requestBody: string = new URLSearchParams({ implementationID: implementationID.toString() }).toString()

  return ObservableFromFetch<string>("FFOrderClinicFileMaintenance/InActivateClinic?" + requestBody)
}
